












import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import EventBuilder from '~/builders/event/EventBuilder'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'

export default Vue.extend({
  components: {
    ViewMobileInfo: () => import('../partials/ViewMobileInfo')
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    forceShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false as boolean
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, ['classified']),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    })
  },
  async mounted() {
    if (this.isMobile) {
      return
    }

    await this.$nextTick()

    this.$dep(EventBuilder)
      .windowWidthResize(this)
      .setBreakpoint(768)
      .onUp(() => {
        this.show = false
      })
      .onDown(() => {
        this.show = true
      })
      .build()
  }
})
